"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PreviewChip = _interopRequireDefault(require("./PreviewChip.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PreviewChip = function PreviewChip(_ref) {
  var children = _ref.children,
    light = _ref.light,
    label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement(_PreviewChip["default"], {
    light: light,
    label: label,
    className: "preview-chip-wrapper"
  }, children);
};
PreviewChip.defaultProps = {
  light: false,
  label: false
};
PreviewChip.propTypes = {
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node.isRequired,
  /** Display chip with lighter colors */
  light: _propTypes["default"].bool,
  /** Display chip as a label. If true, light prop will be ignored */
  label: _propTypes["default"].bool
};
var _default = exports["default"] = PreviewChip;